import sales from "../../../services/sales";
import { router } from "../../../routes";
import Pagination, { Page } from "../../../components/pagination";
import auth from "../../../services/auth";
import invoice from "../../../services/invoice";

export default {
  data() {
    return {
      searchState: undefined,
      orders: undefined,
      loading: undefined,
      messageError: undefined,
      page: new Page(),
      salesOrder: {},
      nfeLinksMap: {},
    };
  },
  computed: {
    currentUser() {
      return auth.currentUser;
    },
    contractId() {
      return this.$route.params.contractId;
    },
  },
  mounted() {
    this.find();
  },
  methods: {
    async find() {
      this.salesOrder = {
        moveMaisId: this.currentUser.moveMaisId,
        planId: undefined,
        type: "",
        status: "",
        page: this.page.build(),
      };

      let promise = sales
        .listSalesOrders(this.salesOrder)
        .then(async (result) => {
          if (result && result.status.code == 9990) {
            this.messageError = result.status.message;
            return false;
          }
          if (result.itens && result.itens.length > 0) {
            this.orders = result.itens;
            this.page = this.page.itemCount(result.total);
            const salesOrderIds = this.orders.map((o) => o.salesOrderId);

            const map = {};
            for (const salesOrderId of salesOrderIds) {
              try {
                const res = await invoice.getLinkNFe(salesOrderId);
                if (
                  res &&
                  res.status &&
                  res.status.code === 0 &&
                  res.return &&
                  Array.isArray(res.return)
                ) {
                  res.return.forEach((entry) => {
                    if (entry.salesOrderId && entry.url) {
                      const key = String(entry.salesOrderId);
                      if (!map[key]) {
                        map[key] = [];
                      }
                      if (!map[key].includes(entry.url)) {
                        map[key].push(entry.url);
                      }
                    }
                  });
                }
              } catch (err) {}
            }
            this.nfeLinksMap = map;
          }
        })
        .catch((error) => {
          if (
            error.data &&
            error.data.status &&
            error.data.status.code == 9990
          ) {
            this.messageError = error.data.status.message;
            return false;
          }
        });
      this.$store.dispatch("loading", promise);
    },
    setCurrentPage(p) {
      this.page = this.page.page(p);
      this.find();
    },
    setPageSize(size) {
      this.page = this.page.size(size);
      this.find();
    },
    showDetail(order) {
      router.push({
        name: "reprocess-order",
        params: { orderId: order.salesOrderId },
      });
    },
    showQRCodePix(order) {
      if (
        order.salesOrderStatus.salesOrderStatusId == 0 &&
        order.pixCopiaCola &&
        order.contractPaymentMethod.paymentMethod.paymentShortName == "PX"
      ) {
        router.push({
          name: "view-qrcode-pix",
          params: {
            code: 0,
            boletoUrl: undefined,
            novoCartao: undefined,
            newPix: true,
            pixCopiaCola: order.pixCopiaCola,
          },
        });
      }
    },
    showReceipt(order) {
      router.push({
        name: "transfer-credit-receipt",
        params: {
          orderId: order.salesOrderId,
        },
      });
    },
    isChangeCard(order) {
      return (
        (order.salesType == "RECARGA" && order.price == 2) ||
        (order.salesType == "RECARGA" && order.price == 100)
      );
    },
    isTransfer(order) {
      return order.salesType == "TRANSFERÊNCIA ENTRE CONTAS";
    },
    getValueClass(price) {
      return Math.sign(price) >= 0 ? "green" : "red";
    },
    exibeVoucher(order) {
      router.push({
        name: "conveniado-voucher",
        params: {
          orderId: order.salesOrderId,
          moveMaisId: order.moveMaisId,
          contractId: order.contractId,
        },
      });
    },
  },
  components: {
    Pagination,
  },
};



// WEBPACK FOOTER //
// ./src/pages/account/request/request.js